import React from 'react';
import { SpaceProps } from 'styled-system';
import { styled } from '@teko/ds-desktop';
import { LazyImage } from '@teko/ui';
import { htmlDecode } from '@teko/utils';

export interface MiniNotificationItemProps extends SpaceProps {
  title: string;
  message: string;
  time?: string;
  isRead?: boolean;
  avatar?: string;
  type?: string;
  onClick?: () => void;
}

interface StyledMiniNotificationItemProps {
  isRead?: boolean;
}

const Wrapper = styled.div<StyledMiniNotificationItemProps>(
  ({ isRead }: StyledMiniNotificationItemProps) => `
  padding: 16px;
  display: flex;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;
  background-color: ${isRead ? 'white' : 'rgb(255, 242, 242)'};
`,
);

const Avatar = styled.div`
  position: relative;
  margin-right: 16px;
  width: 64px;
  height: 64px;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
`;

const ProductImageWrapper = styled.div`
  background-color: unset;
  border-radius: 50%;
`;

const ContentWrapper = styled.div`
  width: calc(100% - 80px);
  .message {
    font-size: 14px;
    color: #848788;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 18px;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  color: #434657;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 8px;
`;

const TimeWrapper = styled.span`
  font-size: 12px;
  color: #82869e;
  line-height: 16px;
  min-width: fit-content;
`;

const MessageWrapper = styled.span`
  font-size: 13px;
  color: #82869e;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 20px;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const MiniNotificationItem: React.FC<MiniNotificationItemProps> = (
  props: MiniNotificationItemProps,
) => {
  const date = new Date(props.time);
  const formatDate = `${date.getDate()}/${
    date.getMonth() + 1
  } - ${date.getHours()}:${date.getMinutes()}`;
  return (
    <Wrapper isRead={props.isRead} {...props}>
      <Avatar>
        {!!props.avatar && (
          <ProductImageWrapper>
            <LazyImage src={props.avatar} alt="" borderRadius={50} contain />
          </ProductImageWrapper>
        )}
      </Avatar>
      <ContentWrapper>
        <HeaderWrapper>
          <TitleWrapper>{props.title}</TitleWrapper>
          {props.time && <TimeWrapper>{formatDate}</TimeWrapper>}
        </HeaderWrapper>
        <MessageWrapper
          dangerouslySetInnerHTML={{ __html: htmlDecode(props.message) }}
        />
      </ContentWrapper>
    </Wrapper>
  );
};
